import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {L10N_LOCALE, L10nLocale, L10nTranslatePipe, L10nTranslationService} from 'angular-l10n';
import {
    FileContainerReq,
    MediaType,
    YascComboBoxModule,
    YascDialogModule,
    YascFileUploadModule,
    YascImageModule,
    YascInputFieldModule,
    YascTextAreaModule
} from '@yasc/yasc-material-components';
import {AgentInfoReq, BugCreateReq} from '../../../core/contracts/v0/core/bug-create-req';
import {FormGroup} from '@angular/forms';
import {MatIcon} from '@angular/material/icon';
import {MatMiniFabButton} from '@angular/material/button';
import {DatePipe, NgForOf} from '@angular/common';
import {HotkeyService} from '../../../core/services/hotkey.service';
import {PipesModule} from '../../../core/pipes/pipes.module';
import {TicketTypeEnum} from '../../../core/enums';

@Component({
    selector: 'cp-bug-report-dialog-component',
    templateUrl: './bug-report-dialog.component.html',
    styleUrl: './bug-report-dialog.component.scss',
    imports: [
        L10nTranslatePipe,
        YascInputFieldModule,
        YascTextAreaModule,
        YascDialogModule,
        MatIcon,
        NgForOf,
        MatMiniFabButton,
        YascImageModule,
        YascFileUploadModule,
        PipesModule,
        YascComboBoxModule
    ],
    providers: [
        DatePipe,
    ]
})
export class BugReportDialogComponent implements OnInit {
    bugReq: BugCreateReq = new BugCreateReq();
    form: FormGroup<any> = new FormGroup<any>({});
    newStepValue: string = "";
    protected readonly mediaTypes = MediaType;
    ticketTypes = TicketTypeEnum;

    constructor(
        public dialogRef: MatDialogRef<BugReportDialogComponent>,
        @Inject(L10N_LOCALE) public locale: L10nLocale,
        protected translation: L10nTranslationService,
        private shortcut: HotkeyService,
        @Inject(MAT_DIALOG_DATA) public data: { route: string, screenshot: string | null },
    ) {
        this.bugReq.route = data.route;
        this.bugReq.attachments = [];
        this.bugReq.stepsToReproduce = [];
        this.bugReq.agentInfo = new AgentInfoReq();

        if (data.screenshot) {
            const file = new FileContainerReq(
                `Screenshot_${new Date().toISOString()}.png`,
                data.screenshot,
                MediaType.Screenshot
            );
            this.bugReq.attachments.push(file);
        }
    }

    ngOnInit(): void {
        this.shortcut.addShortcut({keys: 'enter'}).subscribe(() => this.addStep());
    }

    addStep() {
        if (this.newStepValue !== "" && this.newStepValue !== undefined) {
            this.bugReq.stepsToReproduce.push(this.newStepValue);
            this.newStepValue = "";
        }
    }

    removeStep(step: string) {
        this.bugReq.stepsToReproduce = this.bugReq.stepsToReproduce.filter(e => e !== step);
    }
}
